import { api } from './api';

export interface DiaryPolicy {
  eventReminderMinutes: number[];
  hearingReminderMinutes: number[];
  travelBufferMinutes: number;
  doubleBookingBlocked: boolean;
}

export async function fetchDiaryPolicy(): Promise<DiaryPolicy> {
  return (await api.get('/diary-policy')).data.data as DiaryPolicy;
}

export async function updateDiaryPolicy(input: Partial<DiaryPolicy>): Promise<DiaryPolicy> {
  return (await api.put('/diary-policy', input)).data.data as DiaryPolicy;
}
